import CanvasInput from './CanvasInput.vue';
export default CanvasInput; 